<template>
  <v-app :style="backgroundStyle" style="background-color: white">
    <v-dialog persistent v-model="promptModal.show" max-width="500">
      <v-card>
        <v-card-title
          class="headline"
          v-html="promptModal.title"
        ></v-card-title>
        <v-card-text v-html="promptModal.message"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="
              () => {
                promptModal.show = false
                promptModal.callback(false)
              }
            "
          >
            {{ $t('buttons.no') }}
          </v-btn>
          <v-btn
            color="success"
            @click="
              () => {
                promptModal.show = false
                promptModal.callback(true)
              }
            "
          >
            {{ $t('buttons.yes') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      class="dialog-alert"
      max-width="500"
      v-model="alertModal.show"
    >
      <v-card>
        <v-card-text v-html="alertModal.text"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="alertModal.show = false" :color="alertModal.color">{{
            $t('buttons.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      class="dialog-verify"
      max-width="290"
      persistent
      v-model="verifyModal.show"
    >
      <v-card>
        <v-card-text v-html="verifyModal.text"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="verifyModal.result(false)" color="error">{{
            $t('buttons.no')
          }}</v-btn>
          <v-btn @click="verifyModal.result(true)" color="success">{{
            $t('buttons.yes')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      class="dialog-html"
      max-width="772"
      v-model="htmlModal.show"
    >
      <v-card>
        <v-card-text v-html="htmlModal.text"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="htmlModal.show = false" color="success">{{
            $t('buttons.close')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      class="dialog-verify-html"
      max-width="772"
      v-model="verifyHtmlModal.show"
    >
      <v-card>
        <v-card-text v-html="verifyHtmlModal.text"> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="verifyHtmlModal.result(false)" color="error">{{
            $t('buttons.no')
          }}</v-btn>
          <v-btn @click="verifyHtmlModal.result(true)" color="success">{{
            $t('buttons.yes')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      :top="true"
      class="notification text-xs-center"
      color="primary"
      v-model="notification.show"
      >{{ notification.text }}
    </v-snackbar>
    <div class="loader" v-if="$store.state.loaderCount > 0">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-navigation-drawer
      :touchless="true"
      app
      clipped
      fixed
      v-if="isAuthenticated && $vuetify.breakpoint.xs"
      v-model="drawer"
    >
      <v-list dense>
        <v-list-tile :to="{ path: '/upgrade' }">
          <v-list-tile-action>
            <v-icon color="error">fa-exclamation</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="error--text">
            <v-list-tile-title>{{ $t('modules.upgrade') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ path: '/events' }">
          <v-list-tile-action>
            <v-icon>fa-chart-bar</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('modules.events') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile :to="{ path: '/settings' }">
          <v-list-tile-action>
            <v-icon>fa-cog</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>{{
            $t('modules.settings')
          }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="logoutClick">
          <v-list-tile-action>
            <v-icon>fa-door-open</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ $t('toolbar.logout') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <!-- TODO: Replace absolute with fixed or don't commit this change. -->
    <v-toolbar
      app
      class="main-app-toolbar"
      clipped-left
      absolute
      v-if="isAuthenticated"
    >
      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        v-show="$vuetify.breakpoint.xs"
      ></v-toolbar-side-icon>
      <v-spacer v-show="$vuetify.breakpoint.xs"></v-spacer>
      <router-link :to="{ name: 'Events' }">
        <img
          :src="publicPath + 'img/logo-vote.png'"
          style="max-width: 300px; max-height: 70px"
        />
      </router-link>
      <v-spacer v-show="!$vuetify.breakpoint.xs"></v-spacer>
      <v-toolbar-items v-show="$vuetify.breakpoint.smAndUp">
        <v-btn :to="{ path: '/events' }" flat>
          <v-icon color="primary">fa-chart-bar</v-icon>
          <span class="ml-3">{{ $t('modules.events') }}</span>
        </v-btn>
        <v-btn :to="{ path: '/settings' }" flat>
          <v-icon color="primary">fa-cog</v-icon>
          <span class="ml-3">{{ $t('modules.settings') }}</span>
        </v-btn>
        <v-btn @click="logoutClick" flat>
          <v-icon color="primary">fa-door-open</v-icon>
          <span class="ml-3">{{ $t('toolbar.logout') }}</span>
        </v-btn>
        <v-flex class="pa-3">
          <v-btn
            @click="upgradeClick"
            class="btn-upgrade"
            color="primary"
            v-html="$t('labels.accountUpgrade')"
          >
          </v-btn>
        </v-flex>
      </v-toolbar-items>
    </v-toolbar>
    <v-content class="main-app-container">
      <router-view></router-view>
    </v-content>
    <v-footer class="pa-3 main-app-footer" app>
      <div
        @click="userManualClick"
        class="footer-side-link-left"
        v-if="isAuthenticated"
      >
        <v-icon color="primary" small>fa-file-pdf</v-icon>
        {{ $t('footer.userManual') }}
      </div>
      <v-spacer></v-spacer>
      <div class="footer-middle">
        Powered by
        <a class="footer-link" href="https://ide3.hr" target="_blank">IDE3</a>
      </div>
      <v-spacer></v-spacer>
      <div
        @click="supportClick"
        class="footer-side-link-right"
        v-if="isAuthenticated"
      >
        {{ $t('footer.support') }}
        <v-icon color="primary" small>fa-envelope</v-icon>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import Pusher from 'pusher-js/with-encryption'
import { mapGetters } from 'vuex'
import handle_session_error from '@/helpers/handle_session_error.js'
import axios from 'axios'

// Enable pusher logging - don't include this in production
if (process.env.NODE_ENV !== 'production') {
  Pusher.logToConsole = true
}

// Set Pusher to use credentials. Because we use token
// stored in a cookie to authenticate.
// See this GitHub issue for more info
// https://github.com/pusher/pusher-js/issues/471#issuecomment-659107992
Pusher.Runtime.createXHR = function () {
  var xhr = new XMLHttpRequest()
  xhr.withCredentials = true
  return xhr
}

export default {
  name: 'App',

  data() {
    return {
      publicPath: process.env.BASE_URL,
      drawer: null,

      alertModal: {
        color: 'success',
        show: false,
        text: '',
      },
      promptModal: {
        show: false,
        title: '',
        message: '',
        callback: () => {
          // This is a placeholder for the real callback.
        },
      },
      htmlModal: {
        show: false,
        text: '',
      },
      verifyModal: {
        show: false,
        text: '',
        result: result => {
          this.verifyModal.show = false
          this.verifyModal.reaction(result)
        },
      },
      verifyHtmlModal: {
        show: false,
        text: '',
        result: result => {
          this.verifyHtmlModal.show = false
          this.verifyHtmlModal.reaction(result)
        },
      },
      notification: {
        show: false,
        text: '',
      },
    }
  },

  watch: {
    '$store.state.loggedIn': function (newValue, oldValue) {
      if (oldValue === false && newValue === true) {
        this.initializePusher()
      }

      if (oldValue === true && newValue === false) {
        this.disconnectPusher()
      }
    },
  },

  computed: {
    ...mapGetters(['isAuthenticated']),

    backgroundStyle() {
      if (this.isAuthenticated) {
        return {
          backgroundImage:
            'url(' + this.publicPath + 'img/main-bg-bleak.jpg' + ')',
          backgroundPosition: 'top, right',
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'no-repeat',
        }
      }
      return {}
    },
  },

  methods: {
    disconnectPusher() {
      if (this.$store.state.pusherInstance !== null) {
        // Disconnect from pusher.
        this.$store.state.pusherInstance.disconnect()
      }
    },

    initializePusher() {
      this.$store.dispatch(
        'setPusherInstance',
        new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
          cluster: 'eu',
          authEndpoint: `${process.env.VUE_APP_API_URL}/pusher/auth-private-channel`,
        })
      )

      // When the user goes offline for some reason or if Pusher can't connect for some reason.
      this.$store.state.pusherInstance.connection.bind(
        'unavailable',
        async () => {
          await this.$APILogout()
            .then(() => {
              this.$router.push({ name: 'Login' })
            })
            .catch(error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            })
        }
      )

      this.$store.state.pusherInstance.connection.bind('failed', async () => {
        await this.$APILogout()
          .then(() => {
            this.$router.push({ name: 'BrowserNotSupported' })
          })
          .catch(error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          })
      })

      // Used for channel presence to avoid 100 members limit.
      let pusherChannel_presence = this.$store.state.pusherInstance.subscribe(
        `private-presence-dashboard-user_${this.$store.state.user.session_id}`
      )

      pusherChannel_presence.bind('logout', report_token => {
        this.$store.dispatch('setLoggedIn', false).then(() => {
          this.$router.push({ name: 'Login' })

          this.$prompt(
            this.$t('helpers.handle_session_error.loggedOutPrompt.title'),
            this.$t('helpers.handle_session_error.loggedOutPrompt.message'),
            result => {
              if (result === true) {
                return
              }

              this.$APICall(
                'post',
                'REPORT_WASNT_ME',
                '',
                {
                  token: report_token,
                },
                () => {
                  this.$alert(
                    this.$t(
                      'helpers.handle_session_error.loggedOutAlert.message'
                    )
                  )
                },
                false
              )
            }
          )
        })
      })
    },

    logoutClick() {
      this.$verify(this.$t('alerts.logoutConfirmation'), async result => {
        if (result) {
          await this.$APILogout()
            .then(() => {
              this.$router.push({ name: 'Login' })
            })
            .catch(error => {
              handle_session_error(
                error,
                this.$store,
                this.$router,
                this.$prompt
              )
            })
        }
      })
    },
    upgradeClick() {
      this.$router.push('/upgrade')
    },
    userManualClick() {
      /* this.$alertHtml(
        '<iframe style="border: 0px; border-bottom: 2px solid #707070; height: calc(90vh - 80px);width: calc(100% + 120px); margin-left: -60px; margin-top: -60px; margin-right: -60px;" src="https://docs.google.com/document/d/1FmrgPGBY-1wuV3V-NL9ZF5lL9xngB_WF9sSUHK7ePps/edit"></iframe>'
      ) */
      window.open(
        'https://docs.google.com/document/d/1FmrgPGBY-1wuV3V-NL9ZF5lL9xngB_WF9sSUHK7ePps/edit'
      )
    },
    supportClick() {
      this.$router.push('/support')
    },
  },

  created() {
    // Add a response interceptor
    axios.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response
      },
      error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response.status === 401) {
          this.$store.dispatch('setLoggedIn', false).then(() => {
            this.$router.push({ name: 'Login' })
          })
        }

        return Promise.reject(error)
      }
    )

    if (this.isAuthenticated) {
      this.initializePusher()
    }
  },

  mounted() {
    this.$modalBus.$on('ALERT', data => {
      this.alertModal.text = data.message
      this.alertModal.color = data.color
      this.alertModal.show = true
    })

    this.$modalBus.$on('PROMPT', data => {
      this.promptModal.title = data.title
      this.promptModal.message = data.message
      this.promptModal.callback = data.callback
      this.promptModal.show = true
    })

    this.$modalBus.$on('VERIFY', data => {
      this.verifyModal.text = data.message
      this.verifyModal.reaction = data.response
      this.verifyModal.show = true
    })

    this.$modalBus.$on('ALERT_HTML', message => {
      this.htmlModal.text = message
      this.htmlModal.show = true
    })

    this.$modalBus.$on('VERIFY_HTML', data => {
      this.verifyHtmlModal.text = data.message
      this.verifyHtmlModal.reaction = data.response
      this.verifyHtmlModal.show = true
    })

    this.$modalBus.$on('NOTIFY', message => {
      this.notification.text = message
      this.notification.show = true
    })
  },
}
</script>

<style scoped>
::v-deep .break-all {
  word-break: break-all;
  white-space: normal;
}
</style>

<style scoped>
.loader {
  position: fixed;
  left: 0px;
  top: 0px;
  z-index: 999999;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  font-size: 100px;
  text-align: center;
  padding-top: 100px;
}

/deep/ .theme--light .primary {
  color: #ffffff !important;
}

/deep/ .theme--light .error {
  color: #ffffff !important;
}

/deep/ .theme--light .error i {
  color: #ffffff !important;
}

/deep/ .theme--light .primary i {
  color: #ffffff !important;
}

/deep/ .theme--light .info {
  color: #ffffff !important;
}

/deep/ button {
  box-shadow: none !important;
}

/deep/ .v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: #ffffff !important;
  border: 2px solid #e8e8e8 !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

/deep/ .v-text-field--outline label {
  color: #707070 !important;
}

/deep/ .v-text-field--outline .v-input__slot i {
  color: #707070 !important;
}

/deep/ .v-text-field--outline .v-input__slot input {
  color: #707070 !important;
}

/deep/ .v-text-field--outline .v-input__prepend-outer {
  color: #707070 !important;
}

/deep/ .v-text-field--outline .v-input__prepend-outer i {
  color: #707070 !important;
}

/deep/ textarea {
  color: #707070 !important;
}

/deep/ label.v-label.theme--light {
  color: #707070 !important;
}

/deep/ .dialog-alert .v-card__text {
  color: #707070 !important;
}

/deep/ .dialog-verify .v-card__text {
  color: #707070 !important;
}

/deep/ .dialog-html .v-card__text {
  text-align: justify;
  padding-left: 60px;
  padding-top: 60px;
  padding-right: 60px;
  color: #707070 !important;
}

.footer-link {
  text-decoration: none;
  color: #707070 !important;
}

.footer-side-link-left {
  width: 200px;
  color: #707070;
  cursor: pointer;
}

.footer-side-link-right {
  text-align: right;
  width: 200px;
  color: #707070;
  cursor: pointer;
}

.footer-middle {
  width: 200px;
  text-align: center;
}

/deep/ .v-toolbar__items .v-btn--active:before {
  content: none;
}

/deep/ .v-toolbar__items .v-btn--active {
  border-bottom: 3px solid #88c143;
  border-radius: 0px;
}

/deep/ .main-app-toolbar {
  box-shadow: none;
}

/deep/ .main-app-toolbar .v-toolbar__content {
  height: 90px !important;
  border-bottom: solid 2px #e8e8e8;
  background-color: #ffffff;
}

/deep/ .btn-upgrade {
  height: 50px !important;
  font-size: 10px;
}

/deep/ .main-app-container {
  padding-top: 90px !important;
}

/deep/ .main-app-footer {
  border-bottom: solid #acacac 10px;
  color: #707070 !important;
  font-weight: bold;
}

@media only screen and (max-width: 475px) {
  /deep/ .main-app-footer {
    height: 80px !important;
  }
  /deep/ .footer-side-link-left {
    height: 40px !important;
  }
  /deep/ .footer-side-link-right {
    height: 40px !important;
  }
  /deep/ .footer-middle {
    height: 40px !important;
  }
}

/deep/ .v-input--is-readonly input {
  cursor: default;
}

/deep/ .v-input--is-readonly textarea {
  cursor: default;
}

/deep/ .v-input--is-readonly .v-input--selection-controls__ripple {
  cursor: default;
}

/deep/ .v-input--is-readonly .v-label {
  cursor: default;
}

/deep/ .v-input--is-readonly .v-text-field__slot {
  cursor: default;
}

/deep/ .v-input--is-readonly .v-select__slot {
  cursor: default;
}

/deep/ .grayed-textarea {
  background-color: transparent;
}

/deep/ .grayed-textarea .v-input__control .v-input__slot {
  background-color: #e6e6e6 !important;
}
</style>
